import { Box } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import React from "react";

export const ListLoadingState = () => (
  <React.Fragment>
    {Array.from(Array(10).keys()).map((idx) => (
      <React.Fragment key={idx}>
        <Box display="flex" justifyContent="space-between" paddingLeft={2}>
          <Skeleton width={130} height={21} style={{ marginTop: 16, marginLeft: 0 }} />
          <Skeleton width={48} height={16} style={{ marginTop: 16, marginRight: 16 }} />
        </Box>
        <Skeleton width={270} height={19} style={{ marginBottom: 20, marginLeft: 16 }} />
      </React.Fragment>
    ))}
  </React.Fragment>
);
